import React, { useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import CreateStatHOC from '../hoc/CreateStatHOC';
import EditStatHOC from '../hoc/EditStatHOC';
import CreateStatPopup from '../PopUp/CreateStatPopup';
import EditStatPopup from '../PopUp/EditStatPopup';
import { useStore } from '../../../contexts/StoreProvider';
import { IStatState } from '../../../models/state/IStatState';
import './StatList.css'
import { genderOptions, jobSectorOptions, nationOptions, workPostionOptions } from '../../registration/Registration';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { AgeOptions, test_types } from '../AddEditStatForm/AddEditStatForm';
import { formatMessage } from '../../../translations/format-message';

const StatList = (props: any) => {
    const { adminStore } = useStore();
    const { getStatState, getStatsFilter, allstatsData } = adminStore
    const [statFilterList, setStatFilterList] = useState<Array<IStatState>>([])
    const [fetchStats, setFetchStats] = useState<boolean>(false)
    const [hideAndShow, setHideAndShow] = useState(false)
    const [editStatId, setEditStatId] = useState();
    const [editIndex, setEditStatIndex] = useState();

    const handleCreateStatModalClose = () => {
        props.createStatToggleHandler();
    }
    const handleCreateStatModalOpen = () => {
        props.createStatToggleHandler();
    }
    const handleEditStatModalClose = () => {
        props.EditStatToggleHandler();
    }
    useEffect(() => {
        if(statFilterList.length > 0) {
           getStatsFilter(statFilterList);
        }
    }, [statFilterList])
    
    useEffect(() => {
        if (localStorage.getItem("statFilterList") === null) {
            localStorage.setItem("statFilterList", JSON.stringify([]))
        }
    }, [])

    useEffect(() => {
        const statFilters = JSON.parse((localStorage.getItem("statFilterList") as string));
        setStatFilterList(statFilters);
        if (statFilters.length == 0)
            allstatsData.FilterInfoList = [];
    }, [fetchStats])

    const handleClickDelete = (i: number) => {
        const statFiltersLeft = statFilterList.filter((old: any, index: number) => index !== i)
        localStorage.setItem("statFilterList", JSON.stringify(statFiltersLeft))
        setFetchStats((old: boolean) => !old)
        // if (statFilterList.length > 0) {
        //     getStatsFilter(statFiltersLeft)
        // }
    }

    const handleClickReset = () => {
        localStorage.setItem("statFilterList", JSON.stringify([]));
        setFetchStats((old: boolean) => !old);
    }

    const handleEditEvent = (index: any) => {
        props.EditStatToggleHandler();
        let EditStatValue: any = statFilterList.find((old: any, i: number) => i == index)
        setEditStatId(EditStatValue);
        setEditStatIndex(index)
    }
    const getWorkPositionName = (id:any) => {
        const position = workPostionOptions.find(pos => pos.id === id);
        return position ? position.value : '';
    };
    return (
        <>
            {props.showCreateStatPopup && (
                <CreateStatPopup modalClosed={handleCreateStatModalClose} isLoading={getStatState.inProgress} setFetchStats={setFetchStats} />
            )}
            {props.showEditStatPopup && (
                <EditStatPopup modalClosed={handleEditStatModalClose} isLoading={getStatState.inProgress} setFetchStats={setFetchStats} editStatId={editStatId} editIndex={editIndex} />
            )}
            <div className="dashboar-container  ">
                <div className="dashboard_heading">
                    <div className="container">
                        <h1><FormattedMessage id="Stats" /></h1>
                    </div>
                </div>
                { allstatsData.FilterInfoList.length > 0 && (
                <div className="dashboardTopbar">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-6">
                                {/* <p className="text-dark me-3">
                                
                                    <span><FormattedMessage id="showing" />&nbsp;
                                     {allstatsData.FilterInfoList[0].NumberOfTest}&nbsp;
                                     <FormattedMessage id="stat_Test_Filtered" />
                                     </span>
                                
                                </p> */}
                            </div>
                            <div className="col-6 text-end">
                                <button className='btn btn-primary text-white ' onClick={handleCreateStatModalOpen} disabled = {getStatState.inProgress}><i className="fa fa-filter" ></i> <FormattedMessage id="stat_Add" /> </button>
                                {/* <button className='btn btn-success text-white ms-4' onClick={() => handleClickGet()} ><i className="fa fa-plus" ></i> <FormattedMessage id="stat_Get" /></button> */}
                            </div>
                        </div>
                    </div>
                </div>
                )}
                <div className='container'>
                    <div className='overflow-scroll white-space-nowrap'>
                    
                   {!getStatState.inProgress &&
                    (
                        statFilterList.map((item: any, index: any) => {
                            let slashFlag: Array<number> = [];
                            let isAllTest: boolean = false;
                            return <>
                                <div className='d-inline-flex align-items-center m-2 filter-wrap' style={{background: `${item.Color}`}}>
                                    <div className="d-inline-flex align-items-center">
                                        {
                                            item.Nation != 0 && (
                                                <>
                                                    <span className='filterType'><FormattedMessage id="nation" />: &nbsp;</span><span>
                                                        {nationOptions.find(nation => nation.id == item.Nation)?.value}
                                                        {isAllTest = true}
                                                    </span>
                                                </>
                                            )
                                        }
                                        {
                                            item.Gender != 0 && (
                                                <>
                                                    {
                                                        Object.entries(item).map((e, i) => {
                                                            if ((e[1] != "") || (e[1] != 0)) {
                                                                if (!slashFlag.includes(i))
                                                                    slashFlag.push(i)
                                                            }
                                                        })}
                                                    {
                                                        (slashFlag.filter((m) => m < 1)).length >= 1 && <span>&nbsp;|&nbsp;</span>

                                                    }
                                                    <span className='filterType'><FormattedMessage id="stat_Gender" />:&nbsp;</span>
                                                    <span>
                                                        {formatMessage(genderOptions[item.Gender].value)}
                                                        {isAllTest = true}
                                                    </span>
                                                </>
                                            )
                                        }
                                        {
                                            item.Type != 0 && (
                                                <>
                                                    {
                                                        Object.entries(item).map((e, i) => {
                                                            if ((e[1] != "") || (e[1] != 0)) {
                                                                if (!slashFlag.includes(i))
                                                                    slashFlag.push(i)
                                                            }
                                                        })}
                                                    {
                                                        (slashFlag.filter((m) => m < 2)).length >= 1 && <span>&nbsp;|&nbsp;</span>
                                                    }
                                                    <span className='filterType'><FormattedMessage id="stat_type" />:&nbsp;</span>
                                                    <span>
                                                        {test_types.find(test => test.id == item.Type)?.value}
                                                        {isAllTest = true}
                                                    </span>
                                                </>
                                            )}
                                        {/* {
                                            item.Invited != 0 && (
                                                <>
                                                    {
                                                        Object.entries(item).map((e, i) => {
                                                            if ((e[1] != "") || (e[1] != 0)) {
                                                                if (!slashFlag.includes(i))
                                                                    if (!slashFlag.includes(i)) slashFlag.push(i)
                                                            }
                                                        })}
                                                    {
                                                        (slashFlag.filter((m) => m < 3)).length >= 1 && <>&nbsp;|&nbsp;</>
                                                    }
                                                    <span className='filterType'><FormattedMessage id="stat_Invited" />:&nbsp;</span>
                                                    <span>{item.Invited} </span>
                                                </>
                                            )} */}
                                        {
                                            item.TestIds != 0 && (
                                                <>
                                                    {
                                                        Object.entries(item).map((e, i) => {
                                                            if ((e[1] != "") || (e[1] != 0)) {
                                                                if (!slashFlag.includes(i))
                                                                    slashFlag.push(i)
                                                            }
                                                        })}
                                                    {
                                                        (slashFlag.filter((m) => m < 3)).length >= 1 && <>&nbsp;|&nbsp;</>
                                                    }
                                                    <span className='filterType'><FormattedMessage id="stat_TestIds" />:&nbsp;</span>
                                                    <span>
                                                        {item.TestIds}
                                                        {isAllTest = true}
                                                    </span>
                                                </>
                                            )}
                                        {
                                            item.WorkPositionType != 0 && (
                                                <>
                                                    {
                                                        Object.entries(item).map((e, i) => {
                                                            if ((e[1] != "") || (e[1] != 0)) {
                                                                if (!slashFlag.includes(i))
                                                                  slashFlag.push(i)
                                                            }
                                                        })}
                                                    {
                                                        (slashFlag.filter((m) => m < 4)).length >= 1 && <>&nbsp;|&nbsp;</>
                                                    }
                                                    <span className='filterType'><FormattedMessage id="stat_Workposition" />:&nbsp;</span>
                                                    <span>
                                                        {getWorkPositionName(item.WorkPositionType)}
                                                        {isAllTest = true}
                                                    </span>
                                                </>
                                            )
                                        }
                                        {
                                            item.JobSectorTpye != 0 && (
                                                <>
                                                    {
                                                        Object.entries(item).map((e, i) => {
                                                            if ((e[1] != "") || (e[1] != 0)) {
                                                                if (!slashFlag.includes(i))
                                                                    slashFlag.push(i)
                                                            }
                                                        })}
                                                    {
                                                        (slashFlag.filter((m) => m < 5)).length >= 1 && <>&nbsp;|&nbsp;</>
                                                    }
                                                    <span className='filterType'><FormattedMessage id="stat_JobSector" />:&nbsp;</span>
                                                    <span>
                                                        {jobSectorOptions.find(job => job.id == item.JobSectorTpye)?.value}
                                                        {isAllTest = true}
                                                    </span>
                                                </>
                                            )
                                        }
                                        {
                                            item.AgeRange != 0 && (
                                                <>
                                                    {
                                                        Object.entries(item).map((e, i) => {
                                                            if ((e[1] != "") || (e[1] != 0) || (e[1] != "0")) {
                                                                if (!slashFlag.includes(i))
                                                                    slashFlag.push(i)
                                                            }
                                                        })}
                                                    {
                                                        (slashFlag.filter((m) => m < 6)).length >= 1 && <>&nbsp;|&nbsp;</>
                                                    }
                                                    <span className='filterType'><FormattedMessage id="stat_AgeRange" />:&nbsp;</span>
                                                    <span>
                                                        {AgeOptions.find(age => age.id == item.AgeRange)?.value} 
                                                        {isAllTest = true}
                                                    </span>
                                                </>
                                            )
                                        }
                                        {/* {
                                            item.DOB1 != undefined && (
                                                <>
                                                    {
                                                        Object.entries(item).map((e, i) => {
                                                            if ((e[1] != "") || (e[1] != 0)) {
                                                                if (!slashFlag.includes(i))
                                                                    if (!slashFlag.includes(i)) slashFlag.push(i)
                                                            }
                                                        })}
                                                    {
                                                        (slashFlag.filter((m) => m < 7)).length >= 1 && <>&nbsp;|&nbsp;</>
                                                    }
                                                    <span className='filterType'><FormattedMessage id="stat_DOB1" />:&nbsp;</span>
                                                    <span>{item.DOB1}</span>
                                                </>
                                            )
                                        } */}
                                        {/* {
                                            item.DOB2 != undefined && (
                                                <>
                                                    {
                                                        Object.entries(item).map((e, i) => {
                                                            if ((e[1] != "") || (e[1] != 0)) {
                                                                if (!slashFlag.includes(i))
                                                                    if (!slashFlag.includes(i)) slashFlag.push(i)
                                                            }
                                                        })}
                                                    {
                                                        (slashFlag.filter((m) => m < 8)).length >= 1 && <>&nbsp;|&nbsp;</>
                                                    }
                                                    <span className='filterType'><FormattedMessage id="stat_DOB2" />:&nbsp;</span>
                                                    <span>{item.DOB2}</span>
                                                </>
                                            )} */}
                                            {isAllTest == false && 
                                                <>
                                                    <span className='filterType text-dark'><FormattedMessage id="stat_AllTests" /></span>
                                                </>
                                            }
                                            {allstatsData.FilterInfoList.length > 0 && (
                                                <span key={index} className='text-muted ms-2'>({allstatsData.FilterInfoList[index]?.NumberOfTest})</span>
                                            )}
                                    </div>
                                    <button className='edit-btn btn btn-sm ms-2' onClick={() => handleEditEvent(index)}> <svg height="492pt" viewBox="0 0 492.49284 492" width="492pt" xmlns="http://www.w3.org/2000/svg"><path d="m304.140625 82.472656-270.976563 270.996094c-1.363281 1.367188-2.347656 3.09375-2.816406 4.949219l-30.035156 120.554687c-.898438 3.628906.167969 7.488282 2.816406 10.136719 2.003906 2.003906 4.734375 3.113281 7.527344 3.113281.855469 0 1.730469-.105468 2.582031-.320312l120.554688-30.039063c1.878906-.46875 3.585937-1.449219 4.949219-2.8125l271-270.976562zm0 0"></path><path d="m476.875 45.523438-30.164062-30.164063c-20.160157-20.160156-55.296876-20.140625-75.433594 0l-36.949219 36.949219 105.597656 105.597656 36.949219-36.949219c10.070312-10.066406 15.617188-23.464843 15.617188-37.714843s-5.546876-27.648438-15.617188-37.71875zm0 0"></path></svg></button>
                                    <button className='btn btn-close btn-sm' onClick={() => handleClickDelete(index)}></button>
                                </div>
                            </>
                        })
                    )
                   }         
                    </div>
                    <div className='mb-2 '>   
                    {
                        allstatsData.FilterInfoList.length > 0 && (
                            <button className='btn-link text-danger me-4' onClick={() => handleClickReset()}><small className="fa fa-undo" ></small> <FormattedMessage id="stat_Reset" /></button>
                        )
                    }
                    </div> 

                    {statFilterList.length > 0 && (getStatState.inProgress  || (!getStatState.success && getStatState.error === ''))
                    ?
                    <>
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '150px'}}>
                            <CircularProgress disableShrink={true}/>
                        </Box>
                    </>
                    : 
                    (
                        allstatsData.FilterInfoList.length > 0 ? (
                            <table className='table table-striped stats-table'>
                                <thead className='d-none d-md-table-row'>
                                </thead>
                                <tbody>
                                {
                                        allstatsData.CategoryList.map((category: any) => {
                                            return <>
                                                <tr>
                                                    <td className='text-dark titleColumn'>
                                                        <FormattedMessage id={category.CategoryKey}></FormattedMessage>
                                                    </td>
                                                    <td className='p-0'>
                                                        <table className='m-0 table'>
                                                            <tbody>
                                                            {
                                                                category.SubCategoryList.map((item: any) => {
                                                                    return <>
                                                                        <tr>
                                                                            <td className='subtitleList'> <FormattedMessage id={item.SubCategoryKey}></FormattedMessage>:</td>
                                                                            {item.Results?.map((data:number, index:any)=>{
                                                                                return <td className='subList' style={{background: `${  JSON.parse(localStorage.getItem("statFilterList") as string)?.length > 0 ?  JSON.parse(localStorage.getItem("statFilterList") as string)[index]?.Color : ""}`}}>{Math.round((data + Number.EPSILON) * 100) / 100} </td>
                                                                            })}
                                                                        </tr>
                                                                            

                                                                    </>
                                                                })
                                                            }
                                                            </tbody>
                                                        </table>
                                                    
                                                    </td>
                                                </tr>
                                            </>
                                        })
                                }
                                </tbody>
                            </table>
                    ) : (
                        <div className="d-flex flex-column justify-content-center align-items-center">
                        <svg clip-rule="evenodd" fill-rule="evenodd" height="120" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 64 64" width="120" xmlns="http://www.w3.org/2000/svg"><g id="Exp-2.-F"><path d="m42.251 31.697-10.607 10.606s3.772-1.178 9.193.707c.912.317 2.438-1.209 2.121-2.121-1.885-5.421-.707-9.192-.707-9.192z" fill="#347bfa"/><path d="m13.864 13.916c6.44-6.439 16.895-6.439 23.335 0 6.439 6.44 6.439 16.895 0 23.335-6.44 6.439-16.895 6.439-23.335 0-6.439-6.44-6.439-16.895 0-23.335z" fill="#e9f3fc"/><path d="m35.066 12.114c.748.531 1.462 1.132 2.133 1.802 6.439 6.44 6.439 16.895 0 23.335-6.44 6.439-16.895 6.439-23.335 0-.379-.38-.736-.773-1.071-1.178 6.242 2.028 13.376.564 18.332-4.392 5.286-5.286 6.6-13.05 3.941-19.567z" fill="#cadcf0"/><path d="m12.45 12.502c7.22-7.22 18.943-7.22 26.163 0s7.22 18.943 0 26.163-18.943 7.22-26.163 0-7.22-18.943 0-26.163zm2.121 2.121c6.049-6.049 15.872-6.049 21.921 0s6.049 15.872 0 21.921-15.872 6.049-21.921 0-6.049-15.872 0-21.921z" fill="#a4bbdb"/><path d="m8.957 33.81c-3.432-6.919-2.268-15.547 3.493-21.308 5.41-5.41 13.348-6.766 20.027-4.068.048.613.073 1.234.073 1.861 0 .484-.015.965-.044 1.443-5.811-2.926-13.085-1.964-17.935 2.885-5.141 5.141-5.913 13.008-2.314 18.968-1.054.144-2.13.219-3.222.219z" fill="#b9cae3"/><path d="m40.027 46.443c-1.757-1.757-1.757-4.606 0-6.364 1.757-1.757 4.607-1.757 6.364 0l14.496 14.496c.39.39-.719 2.133-2.475 3.889s-3.499 2.865-3.889 2.475z" fill="#a4bbdb"/><path d="m40.027 46.443c-1.757-1.757-1.757-4.606 0-6.364 1.757-1.757 4.607-1.757 6.364 0l13.12 13.12c.39.39-.719 2.133-2.475 3.889s-3.499 2.865-3.889 2.475z" fill="#cadcf0"/><g fill="#347bfa"><path d="m23.413 22.435c-.023-.953.335-1.649.887-2.057.868-.64 2.165-.613 2.869.18.302.341.477.823.482 1.433.012 1.463-.674 2.318-1.346 3.203-.904 1.193-1.807 2.419-1.919 4.466-.03.552.394 1.023.945 1.053s1.023-.393 1.053-.944c.084-1.555.828-2.461 1.515-3.367.92-1.213 1.769-2.423 1.752-4.427-.01-1.178-.403-2.087-.987-2.745-1.364-1.536-3.869-1.702-5.551-.462-1.008.744-1.741 1.976-1.7 3.714.013.552.472.989 1.024.976.551-.013.989-.471.976-1.023z"/><circle cx="25.292" cy="33.197" r="1.23"/><path d="m43.288 8.497 3-5c.284-.473.131-1.088-.343-1.372-.473-.283-1.088-.13-1.372.343l-3 5c-.284.474-.13 1.089.343 1.372.474.284 1.088.131 1.372-.343z"/><path d="m48.019 11.792 11-8c.446-.325.545-.951.221-1.397-.325-.447-.951-.545-1.397-.221l-11 8c-.447.325-.545.951-.221 1.397.325.447.951.545 1.397.221z"/><path d="m49.673 17.953 8-2c.536-.134.862-.677.728-1.213-.134-.535-.677-.861-1.213-.727l-8 2c-.535.134-.861.677-.727 1.213.134.535.677.861 1.212.727z"/></g></g></svg>
                        <p className="noData text-muted text-center h4 mb-0"><FormattedMessage id="no_stat" /></p>
                        <p className="mb-3"><FormattedMessage id="no_stat_details" /></p>
                        <button className='btn btn-primary text-white ' onClick={handleCreateStatModalOpen}><i className="fa fa-filter" ></i> <FormattedMessage id="stat_Add" /> </button>
                    </div>
                  
                    ))}
                </div>
            </div>
        </>
    )
}

export default EditStatHOC(CreateStatHOC(injectIntl(observer(StatList))));

